export default "/_next/static/chunks/fonts/Channel4Chadwick-ExtraLight-143ac1dfbc782ca5ac3fe4985ffd4238.woff2";